import {Controller} from "@/controllers/Controller";

/**
 * Controller for connection API (ms-marketing) : comptes des réseaux sociaux reliés (LinkedIn) et import de leurs publications
 */
export class ConnectionController extends Controller {

    // Connexions du groupe (jamais leurs jetons) et si le serveur sait se connecter à LinkedIn
    static getAll() {
        return this.requestBuilder("GET", `/marketing/connections`, true);
    }

    // Adresse de LinkedIn où envoyer le navigateur pour autoriser l'accès
    static linkedinAuthorizeUrl() {
        return this.requestBuilder("GET", `/marketing/connections/linkedin/authorize`, true);
    }

    // Lit les publications de la page sur LinkedIn et crée (ou actualise) celles du Gestionnaire
    static importPage(connectionId, pageId) {
        return this.requestBuilder("POST", `/marketing/connections/${connectionId}/pages/${encodeURIComponent(pageId)}/import`, true);
    }

    static disconnect(connectionId) {
        return this.requestBuilder("PATCH", `/marketing/connections/disconnect/${connectionId}`, true);
    }
}
